import dynamic from 'next/dynamic'
import { SearchDesktopProps } from './SearchDesktopFields'

export const DynamicSearchDesktopFields = dynamic<SearchDesktopProps>(() =>
  import('./SearchDesktopFields').then((md) => md.SearchDesktopFields)
)
